import { useEffect } from "react";

function useOnWindowSizeChange(callback: () => void) {
  useEffect(() => {
    const handleResize = () => {
      callback();
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [callback]);
}

export default useOnWindowSizeChange;
